// extracted by mini-css-extract-plugin
export var cookieDeclaration = "CookieBotDeclarations-module--cookie-declaration--55d51";